import { BrowserRouter } from 'react-router-dom';
import { Route, Routes } from 'react-router-dom';
import {
    ACCEPT_INVITE,
    FORGOT_PASSWORD,
    RESET_PASSWORD,
    REACTIVATE_USER,
    RETURN_TO_APP,
    RESUME_BUILDER_ROOT_ROUTE,
    JOIN_LINK,
    VERIFY_EMAIL_CHANGE
} from '@src/PublicApp/domain/publicRoutes';
import { Suspense } from 'react';
import React from 'react';

type ComponentModule = {
    // @ts-expect-error ts-migrate(2694) FIXME: Namespace 'React' has no exported member 'Abstract... Remove this comment to see the full error message
    default: React.AbstractComponent<React.Config<any, any>>;
};
const lazyLoadComponent = (importComponent: () => Promise<ComponentModule>) =>
    React.createElement(React.lazy(importComponent));

const AppInitializer = lazyLoadComponent(
    () =>
        import(
            /* webpackChunkName: "AppInitializer" */
            './AppInitializer'
        )
);
const PublicAppInitializer = lazyLoadComponent(
    () =>
        import(
            /* webpackChunkName: "PublicAppInitializer" */
            '../PublicApp/PublicAppInitializer'
        )
);

/**
 * This component dynamically loads authenticated (AppInitializer) or
 * public (PublicApp) components based on the page Url
 */
const AppRouter = () => {
    const urlpath = window.location.pathname;

    const isPublicApp =
        urlpath.startsWith(FORGOT_PASSWORD) ||
        urlpath.startsWith(ACCEPT_INVITE) ||
        urlpath.startsWith(RESET_PASSWORD) ||
        urlpath.startsWith(REACTIVATE_USER) ||
        urlpath.startsWith(RETURN_TO_APP) ||
        urlpath.startsWith(RESUME_BUILDER_ROOT_ROUTE) ||
        urlpath.startsWith(JOIN_LINK) ||
        urlpath.startsWith(VERIFY_EMAIL_CHANGE);

    if (isPublicApp) {
        return (
            <BrowserRouter>
                <Suspense fallback={null}>{PublicAppInitializer}</Suspense>
            </BrowserRouter>
        );
    }

    return (
        <BrowserRouter>
            <Routes>
                <Route
                    path="*"
                    element={
                        <Suspense fallback={null}>{AppInitializer}</Suspense>
                    }
                />
            </Routes>
        </BrowserRouter>
    );
};
export default AppRouter;
